import OrderTracker, { OrderTrackerProps } from './OrderTracker';

export type { OrderTrackerProps };
export default OrderTracker;
